import React from "react";
import IpadCardList from "./IpadCardList";

const IpadCardAll = () => {
  return (
    <>
      <IpadCardList />
    </>
  );
};

export default IpadCardAll;
